import React, { useState } from 'react'

import './style.css'
import LoadingIndicator from 'src/components/LoadingIndicator'
import CustomCheckbox from 'src/components/CustomCheckbox'
import { NavButton } from '../navigation/nav'
import Info from '../Info'

export const Form = ({ onClose = () => { } }) => {
  const [loading, setLoading] = useState(false)
  const [agree, setAgree] = useState(false)
  const [successMessage, setSuccessMessage] = useState(null)
  const [errorMessage, setErrorMessage] = useState(null)

  const [emailError, setEmailError] = useState(null)
  const [companyError, setCompanyError] = useState(null)
  const [agreeError, setAgreeError] = useState(null)
  const [policyNumberError, setPolicyNumberError] = useState(null)

  const [firstName, setFirstName] = useState('')
  const [policyNumber, setPolicyNumber] = useState('')
  const [email, setEmail] = useState('')
  const [companyName, setCompanyName] = useState('')


  const clearForm = () => {
    setFirstName('')
    setPolicyNumber('')
    setEmail('')
    setCompanyName('')
    setAgree(false)
    setAgreeError(null)
    setPolicyNumberError(null)
  }

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  }

  const handleSendForm = () => {
    if (!validateEmail(email)) {
      setEmailError(true)
    }
    if (!companyName) {
      setCompanyError(true)
    }
    if (!agree) {
      setAgreeError(true)
    }
    if (!policyNumber) {
      setPolicyNumberError('Please check Policy number')
    }

    if (validateEmail(email) && !!companyName && agree && !!policyNumber) {
      setLoading(true)
      const data = {
        email,
        fullName: firstName,
        companyName,
        policyNumber,
      }


      fetch(window._env_.REACT_APP_API_HOST + '/external/pen/activate', {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }).then(resp => {
        if (resp.ok) {
          setLoading(false)
          clearForm()
          setSuccessMessage('Success! Data has been sent.')
          setTimeout(() => {
            onClose()
          }, 5000);
        } else {
          resp.json().then(response => {
            if (response.code == 'COMPANY_ERROR_010') {
              setLoading(false)
              setPolicyNumberError(response.description)
              return
            }
            setLoading(false)
          }
          ).catch(err => {
            console.error(err);
            setLoading(false)
          })
        }
      })

    }

  }

  return (
    <div style={{ opacity: loading ? 0.5 : 1, position: 'relative', padding: '20px' }} className='column'>
      {loading && <div style={{ position: 'absolute', background: '#ffffff40', width: 'calc( 100% - 60px)', height: 'calc( 100% - 160px)', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', boxSizing: 'border-box' }}>
        <LoadingIndicator />
      </div>}
      {successMessage &&
        <div className='column column-center' style={{ justifyContent: 'center', height: '210px' }}>
          <svg style={{ marginBottom: '30px' }} width="100" height="100" viewBox="0 0 218 219" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_di_1_735)">
              <mask id="path-1-inside-1_1_735" fill="white">
                <path d="M16.8527 60.7004C16.8527 36.6364 36.3605 17.1286 60.4245 17.1286H157.623C181.687 17.1286 201.195 36.6364 201.195 60.7004V157.899C201.195 181.963 181.687 201.471 157.623 201.471H60.4246C36.3605 201.471 16.8527 181.963 16.8527 157.899V60.7004Z" />
              </mask>
              <path d="M16.8527 60.7004C16.8527 36.6364 36.3605 17.1286 60.4245 17.1286H157.623C181.687 17.1286 201.195 36.6364 201.195 60.7004V157.899C201.195 181.963 181.687 201.471 157.623 201.471H60.4246C36.3605 201.471 16.8527 181.963 16.8527 157.899V60.7004Z" fill="#2DC38C" />
              <path d="M16.8527 17.1286H201.195H16.8527ZM201.195 157.899C201.195 188.905 176.06 214.04 145.054 214.04H72.9933C41.9877 214.04 16.8527 188.905 16.8527 157.899C16.8527 175.022 36.3605 188.902 60.4245 188.902H157.623C181.687 188.902 201.195 175.022 201.195 157.899ZM16.8527 201.471V17.1286V201.471ZM201.195 17.1286V201.471V17.1286Z" fill="#2DC38C" mask="url(#path-1-inside-1_1_735)" />
            </g>
            <g filter="url(#filter1_d_1_735)">
              <path d="M67.1279 100.71L89.0388 127.003C92.2454 130.851 98.0892 131.044 101.544 127.417L150.92 75.572" stroke="white" strokeWidth="16.7584" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
              <filter id="filter0_di_1_735" x="8.47351" y="-3.81942" width="201.101" height="213.67" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feMorphology radius="8.3792" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1_735" />
                <feOffset />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0.806057 0 0 0 0 0.943424 0 0 0 0 0.893056 0 0 0 0.3 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_735" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_735" result="shape" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset dy="-20.948" />
                <feGaussianBlur stdDeviation="12.5688" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix type="matrix" values="0 0 0 0 0.386074 0 0 0 0 0.918896 0 0 0 0 0.723528 0 0 0 1 0" />
                <feBlend mode="normal" in2="shape" result="effect2_innerShadow_1_735" />
              </filter>
              <filter id="filter1_d_1_735" x="25.2317" y="50.4344" width="167.584" height="138.238" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset dy="16.7584" />
                <feGaussianBlur stdDeviation="16.7584" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.34 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_735" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_735" result="shape" />
              </filter>
            </defs>
          </svg>

          <p style={{
            color: '#3F8367',
            marginBottom: 20,
            marginTop: -20,
            fontWeight: 600
          }}>{successMessage}</p>
        </div>
      }
      {errorMessage && <p style={{
        color: '#B70000',
        marginBottom: 20,
        marginTop: -20,
        fontWeight: 600
      }}>{errorMessage}</p>}
      {!successMessage && <>
        <label htmlFor="firstName" >Full Name</label>
        <input value={firstName} onChange={e => setFirstName(e.target.value)} style={{ padding: '0px 20px' }} id="firstName" type="text" />

        <label htmlFor="email" >Work email<span style={{ color: '#B70000' }}>*</span></label>
        <input value={email} onChange={e => {
          setEmail(e.target.value)
          setEmailError(null)
        }} style={{ padding: '0px 20px' }} id="email" type="text" />
        {emailError && <p style={{ color: '#B70000', margin: '-15px 0px 20px 0px' }}>Please check email</p>}


        <div className='row row-center'>
          <label htmlFor="firstName" >Policy number<span style={{ color: '#B70000' }}>*</span></label>
          <Info
            style={{
              marginBottom: 11
            }}
            text={<>
              <p style={{ fontWeight: 700, marginBottom: 10 }}>Policy number could come in any of the following formats:</p>
              <div className='row' style={{ width: 300 }}>
                <div className='column' style={{ marginRight: 14 }}>
                  <p>UK Gallagher</p>
                  <p>UK Broker</p>
                  <p>Canada</p>
                  <p>New Zealand</p>
                  <p>Australia</p>
                  <p>US</p>
                </div>
                <div className='column'>
                  <p>PC-XXXXXX</p>
                  <p>P-PEN-CYB-XXXXXX</p>
                  <p>P-PEN-CYBCA-XXXXXX</p>
                  <p>OMP/AKL/XXXXX</p>
                  <p>01A2B/0123456</p>
                  <p>RPS-P-XXXXXXX</p>
                </div>
              </div>
            </>}
          />
        </div>
        <input value={policyNumber} onChange={e => setPolicyNumber(e.target.value)} style={{ padding: '0px 20px' }} id="insuranceNumber" type="text" />
        {policyNumberError && <p style={{ color: '#B70000', margin: '-15px 0px 20px 0px' }}>{policyNumberError}</p>}


        <label htmlFor="companyName" >Company name<span style={{ color: '#B70000' }}>*</span></label>
        <input value={companyName} onChange={e => {
          setCompanyName(e.target.value)
          setCompanyError(null)
        }} style={{ padding: '0px 20px' }} id="companyName" type="text" />
        {companyError && <p style={{ color: '#B70000', margin: '-15px 0px 20px 0px' }}>Company name is required</p>}

        <div className='row ' style={{ marginBottom: 20 }}>
          <CustomCheckbox checked={agree} onChange={() => {
            setAgree(!agree)
            setAgreeError(null)
          }} />
          <label htmlFor="consent" style={{
            margin: '0px 0px 0px 10px', lineHeight: 1.5, ...(agreeError && {
              textDecorationLine: 'underline',
              textDecorationStyle: 'wavy',
              textDecorationColor: '#B70000'
            }
            )
          }} ><p>By clicking the button you agree <br /> with our <a href='https://www.penunderwriting.co.uk/privacy-policy' target='_blank' className='form-link' rel="noreferrer">Privacy Policy</a><span style={{ color: '#B70000' }}>*</span></p></label>
        </div>
        <div className='text-center'>

          <NavButton fullwidth={true} onClick={handleSendForm} variant='dark' size='md' >Confirm Activation</NavButton>
        </div>
      </>}
    </div>
  )
}
